import { useCallback, useEffect, useState } from "react";
import { axios, errorResponse } from "../../helpers";

const useTopSalesProducts = (token, limit = 5) => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const formatProducts = useCallback((items) => {
    return items.map((product) => {
      const productName = product.fabric_name || product.productName || "N/A";

      return {
        id: product._id,
        name: productName,
        category: product.productCategory || "N/A",
        totalTransactions: product.totalTransactions || 0,
        totalSales: new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        }).format(product.totalSales || 0),
        rawTotalSales: product.totalSales || 0,
        image: product.productImage || "https://placehold.co/60x60/png",
      };
    });
  }, []);

  const fetchTopProducts = useCallback(async () => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(
        `/v1/dashboard/top-products?limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setProducts(formatProducts(response.data.data));
        setError("");
      } else {
        setError(response.data.message || "Failed to fetch top products");
      }
    } catch (err) {
      const msg = errorResponse(err) || "Error fetching top products";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  }, [token, limit, formatProducts]);

  useEffect(() => {
    fetchTopProducts();
  }, [fetchTopProducts]);

  return { products, isLoading, error, refetch: fetchTopProducts };
};

export default useTopSalesProducts;
